
import { NgModule, APP_INITIALIZER,CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, CommonModule } from '@angular/common';

import { AppComponent } from './app.component';

import { FileSaverModule } from 'ngx-filesaver';
import { ArchwizardModule } from 'angular-archwizard';
import { AuthenticationService } from '../app/services/authentication.service';
import { AuthguardGuard } from '../app/authguard.guard';
import { AdminguardGuard } from '../app/adminguard.guard';
import { ApiService } from '../app/services/api.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http'
import { AppRoutingModule } from './/app-routing.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { HttpClientModule } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

// import { Ng2ImgMaxModule } from "ng2-img-max";
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { srvThemeLoader } from './shared/theme-loader';
import { BrowserModule } from '@angular/platform-browser';

import { DatePipe } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TreeviewModule } from 'ngx-treeview';

import { CanDeactivateGuard } from './shared/directives/canDeactivate/canDeactivateGuard'
import { InternationalizationModule } from './internationalization/internationalization.module';
import { FormsModule } from '@angular/forms';
import { NgxLoadingModule } from "ngx-loading";



/**
* The http loader factory : Loads the files from define path.
* @param {HttpClient} http
* @returns {TranslateHttpLoader}
* @constructor
*/
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function appMasterInitFactory(themeSrv: srvThemeLoader): () => Promise<any> {
  return () => themeSrv.getMasterDataCollection()
}
export function appThemeInitFactory(themeSrv: srvThemeLoader): () => Promise<any> {
  return () => themeSrv.getTheme();
}
export function appgetLocation(themeSrv: srvThemeLoader): () => Promise<any> {
  return () => themeSrv.getIpAddress()
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,

  
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    InternationalizationModule.forRoot({ locale_id: 'en' }), // iniating with default language: en-US
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate:false
    }),
    NgxLoadingModule,
    AppRoutingModule,
    ArchwizardModule.forRoot(),
    TreeviewModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
      progressBar: true,
      tapToDismiss: false,
      autoDismiss: false,
      closeButton: true,
    }),
    AppRoutingModule,
    FileSaverModule,
    
  ],
  exports: [TranslateModule],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy }, 
    DatePipe, NgbActiveModal,
    AuthenticationService, AuthguardGuard, AdminguardGuard, CanDeactivateGuard, ApiService,
    {provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true, },
    srvThemeLoader,
      {provide: APP_INITIALIZER, useFactory: appMasterInitFactory, deps: [srvThemeLoader], multi: true },
      {provide: APP_INITIALIZER, useFactory: appThemeInitFactory, deps: [srvThemeLoader], multi: true },
      {provide: APP_INITIALIZER, useFactory: appgetLocation, deps: [srvThemeLoader], multi: true}
  ],
  entryComponents: [],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule {}
